/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.witchsky.theme.defs'

type $nsid = typeof $nsid

export { $nsid }

type MaterialYou = {
  $type?: 'app.witchsky.theme.defs#materialYou'

  /**
   * Hex accent used to generate this Material You example on clients without a system palette.
   */
  accent: string
}

export type { MaterialYou }

const materialYou = /*#__PURE__*/ l.typedObject<MaterialYou>(
  $nsid,
  'materialYou',
  /*#__PURE__*/ l.object({ accent: /*#__PURE__*/ l.string({ maxLength: 7 }) }),
)

export { materialYou }

/** Indicates that a client may offer a hue-shift control for this theme. */
type Hue = { $type?: 'app.witchsky.theme.defs#hue' }

export type { Hue }

/** Indicates that a client may offer a hue-shift control for this theme. */
const hue = /*#__PURE__*/ l.typedObject<Hue>(
  $nsid,
  'hue',
  /*#__PURE__*/ l.object({}),
)

export { hue }
